module.exports = __webpack_public_path__ + "img/twitter.13c4f2a0.svg";